module.exports = __webpack_public_path__ + "media/product/cta-04-7d03ffb3.png";